<!--
  @Description: 数据产品右侧导航
  @Author: wang.y 
  @Date: 2022-02-18 
-->
<template>
  <div class="data-nav2">
    <Affix :offset-top="offset_top" @on-change="affixChange" id="dara-affix">
      <div class="data-nav" ref="data-nav" :style="'transform: translateY(' + translate_y + 'px);'">
        <div class="list">
          <div class="li" v-for="item,index in list" :key="index">
            <div class="head" :class="{'active': item.arr.findIndex(a => linkHighLight(a)) > -1}">
              <!-- <img :src="static_img_url+'pic/vbdata2.0/nav1-icon.png'" /> -->
              <span>{{item.name}}</span>
              <img v-if="item.new" :src="static_img_url + 'pic/new.png'" />
              <img v-if="item.hot" :src="static_img_url + 'pic/hot.png'" />
            </div>
            <div class="cnt">
              <div class="item" v-for="item2,index2 in item.arr" :key="index2">
                <span @click="handleChangeRouter(item2)" :class="{'on': linkHighLight(item2) }" class="menu-item">{{item2.name}}</span>
                <img v-if="item2.new" :src="static_img_url + 'pic/new.png'" />
                <img v-if="item2.hot" :src="static_img_url + 'pic/hot.png'" />
              </div>
            </div>
          </div>
          <!-- <div class="li">
            <div class="head">
              <img :src="static_img_url+'pic/vbdata2.0/nav2-icon.png'" />
              <span>产品</span>
            </div>
            <div class="cnt2">
              <div class="org-img">
                <img :src="static_img_url+'pic/vbdata2.0/org-icon.png'" @click="haddleApplyTry2(26)" 
                      onclick="_czc.push(['_trackEvent', '左侧菜单(新)', '产品(动脉橙机构版)', '点击量'])"/>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </Affix>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  inject: ['reload', 'login', 'haddleApplyTry2'],
  components: {},
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      static_img_url: (state) => state.static_img_url,
      index_path: (state) => state.index_path,
      index2_path: (state) => state.index2_path,
    }),
    wx_image() {
      if (this.user) {
        return this.user.wx_avatarurl
      } else {
        return false
      }
    },
    isShowNavigation() {
      const router_arr = ['Index', 'IntelDetail', 'IntelAuthor', 'LinkDetail', 'LinkList']
      return router_arr.indexOf(this.$route.name) > -1
    },
    linkHighLight() {
      return function(item) {
        if(!item.query) return item.router_path == this.$route.path
        else {
          if(!this.$route.query) return false
          let toTrue = true
          for(let prop in item.query) {
            toTrue = toTrue && (item.query[prop] == this.$route.query[prop])
          }
          return item.router_path == this.$route.path && toTrue
        }
      }
    }
  },
  created() {},
  mounted() {
    this.$nextTick(() => {
      this.scrollChange()
      if (this.$route.name != 'reportingDetail' && this.$route.name != 'CompanyFilter') {
        window.onscroll = this.debounce(this.scrollChange, 10)
      }
    })
  },
  beforeDestroy() {
    window.onscroll = ''
  },
  data() {
    return {
      offset_top: 0,
      translate_y: 0,
      list: [
        {
          name: '常用功能', icon_path: '', arr: [
            { name: '看赛道', router_path: '/searchTrack', is_blank: false, index: 1, hot: false, type:'常用功能(看赛道)' },
            { name: '找公司', router_path: '/companyList', is_blank: false, index: 1, hot: false, type:'常用功能(找公司)' },
            { name: '看报告', router_path: '/reportingDetail', is_blank: false, index: 1, hot: false, type:'常用功能(看报告)' },
            { name: '7x24H情报', router_path: '/intelList', is_blank: false, index: 2, new: true, type:'常用功能(7x24H情报)' },
            // { name: '发现', router_path: '/intelDiscoverList', is_blank: false, index: 2, new: true, type:'常用功能(发现)' },
            // { name: '快讯Live', router_path: '/newsList', is_blank: true, index: 1, type:'常用功能(快讯Live)' },
            { name: '专题Pro', router_path: '/specialList', is_blank: true, index: 1, type:'常用功能(专题Pro)' },
            { name: '研图View', router_path: '/financing', is_blank: true, index: 1, type:'常用功能(研图View)' },
            { name: '我的关注', router_path: '/myAttention', is_login: true, is_blank: false, index: 1, type:'常用功能(我的关注)' },
            { name: '我的收藏', router_path: '/collect', is_login: true, is_blank: false, index: 2, type:'常用功能(我的收藏)' }
          ]
        },
        {
          name: '产业链接库', new: true, icon_path: '', arr: [
            { name: '需求', router_path: '/linkList', query: {type: 1}, is_blank: false, index: 2, hot:true, type:'产业链接库(需求)' },
            { name: '供给', router_path: '/linkList', query: {type: 2}, is_blank: false, index: 2, hot:true, type:'产业链接库(供给)' },
          ]
        },
        {
          name: '实体数据库', icon_path: '', arr: [
            { name: '公司', router_path: '/companyList', is_blank: true, index: 1, type:'实体数据库(公司)' },
            { name: '金融机构', router_path: '/orgList', is_blank: true, index: 1, type:'实体数据库(金融机构)' },
            { name: '医院', router_path: '/hospitalList', is_blank: true, index: 1 , type:'实体数据库(医院)' },
            { name: '产业园区', router_path: '/parkList', is_blank: true, index: 1 , type:'实体数据库(产业园区)' },
          ]
        },
        {
          name: '金融数据库', icon_path: '', arr: [
            { name: '投资事件', router_path: '/eventList', is_blank: true, index: 1, type:'金融数据库(投资事件)' },
            { name: '并购事件', router_path: '/mergersList', is_blank: true, index: 1, type:'金融数据库(并购事件)' },
            { name: '公告库', router_path: '/noticeList', is_blank: true, index: 1, type:'金融数据库(公告库)' },
            { name: '招股书', router_path: '/prospectusList', is_blank: true, index: 1, type:'金融数据库(招股书)' },
            { name: '股价信息', router_path: '/stockList', is_blank: true, index: 1, type:'金融数据库(股价信息)' },
            { name: '财务数据', router_path: '/financeList', is_blank: true, index: 1, type:'金融数据库(财务数据)' }
          ]
        },
        {
          name: '产业数据库', icon_path: '', arr: [
            { name: '政策数据', router_path: '/policyList', is_blank: true, index: 1, type:'产业数据库(政策数据)' },
            { name: '行业报告', router_path: '/reportList', is_blank: true, index: 1, type:'产业数据库(行业报告)' },
            { name: '招投标数据', router_path: '/tenderList', is_blank: true, index: 1, type:'产业数据库(招投标数据)' },
            { name: '活动数据', router_path: '/actList', is_blank: true, index: 1, type:'产业数据库(活动数据)' },
            { name: '产品数据', router_path: '/productList', is_blank: true, index: 1, type:'产业数据库(产品数据)' },
            { name: '行业宏观数据', router_path: '/industryList', is_blank: true, index: 1, type:'产业数据库(行业宏观数据' }
          ]
        }
      ],
      is_affix: false,
    }
  },
  methods: {
    handleChangeRouter(item) {
      _czc.push(['_trackEvent', '左侧菜单(新)', item.type, '点击量'])
      if (item.is_login && !this.$store.state.user_key) {
        this.login()
        return
      }
      let query_str = ''
      if (item.query) {
        query_str = '?'
        let props = Object.keys(item.query)
        props.forEach((prop, index) => {
          let and = index > 0 ? '&' : ''
          query_str = query_str + and + prop + '=' + item.query[prop]
        })
      }
      if (item.index == 1) {
        if (item.is_blank) {
          const href = this.index_path + item.router_path + query_str
          window.open(href, '_blank')
        } else {
          this.$router.push({ path: item.router_path, query: item.query })
        }
      } else {
        if (item.is_blank) {
          const href = this.index2_path + item.router_path + query_str
          window.open(href, '_blank')
        } else {
          const href = this.index2_path + item.router_path + query_str
          window.location.href = href
        }
      }
    },
    /**
     * @description: 滚动条防抖
     * @param {*} fn
     * @param {*} wait
     * @return {*}
     */
    debounce(fn, wait) {
      let timeout = null
      return () => {
        if (timeout !== null) {
          clearTimeout(timeout)
        }
        timeout = setTimeout(fn, wait)
      }
    },
    scrollChange() {
      let footer_height = document.getElementById('home-footer').offsetHeight
      let header_height = document.getElementById('home-header').offsetHeight
      let scroll_top = document.documentElement.scrollTop || document.body.scrollTop //滚动条的值
      let y = scroll_top + window.innerHeight + footer_height - document.body.clientHeight
      // console.log(y)
      this.translate_y = y > -1 ? 0 - y : 0

      let num = window.innerHeight - this.$refs['data-nav'].clientHeight - 20
      this.offset_top = num > header_height ? header_height + 20 : num

      let affix_dom = document.querySelector('#dara-affix .ivu-affix')
      if(!affix_dom) return
      if (this.is_affix){
        affix_dom.style.left = 'auto'
        affix_dom.style.top = this.offset_top + 'px'
      } else {
        affix_dom.style.top = 'auto'
        affix_dom.style.left = 'auto'
      }
    },
    affixChange(val) {
      this.is_affix = val
    },
  },
}
</script>
<style lang="stylus" scoped>
.data-nav2
  margin-top 20px
  width 126px
  display flex
  justify-content flex-end
  > div
    width 126px
    flex 0 0 126px
.data-nav
  background #fff
  box-shadow 0px 10px 30px 0px rgba(121, 133, 143, 0.1)
  .top
    display flex
    justify-content center
    align-items center
    height 48px
    span
      font-size 12px
      color #999
      margin-left 4px
    .logo
      height 16px
      cursor pointer
  .list
    .li
      .head
        padding-left 20px
        height 42px
        background #FFF8F2
        display flex
        align-items center
        position relative
        img
          width 25px
          height 14px
          margin-left 5px
        span
          font-size 14px
          color #FA5A00
      .active
        background #FA5A00
        span
          color #fff
      .cnt
        padding 20px 0 20px 20px
        .item
          line-height 1
          font-size 0
          display flex
          align-items center
          &+.item
            margin-top 20px
          .menu-item
            font-size 14px
            cursor pointer
            &:hover
              color #FA5A00
            &.on
              color #FA5A00
          img
            margin-left 5px
            width 25px
            height 14px
      .cnt2
        padding 20px 0 20px
        text-align center
        .org-img
          font-size 0
          img
            cursor pointer
</style>